import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Image, Skeleton, Text } from '@chakra-ui/react';
import { DeleteOutline } from '@mui/icons-material';

import { getProductById } from '../services/ProductServices';
import { QuantityStepper } from './product/PdpParts';
import { formatPrice } from './product/productUtils';

// One cart line (design-system.md §4.6): thumbnail, name, size / colour, stepper, line total, delete.
// `compact` for the cart drawer.
const CartLine = ({ item, onChangeAmount, onRemove, compact = false, product: given }) => {

    const [product, setProduct] = useState(given || null);

    useEffect(() => {
        if (given) { setProduct(given); return; }
        getProductById(item.id).then(result => setProduct(result.product)).catch(() => { });
    }, [item.id, given]);

    if (!product) return <Skeleton height={compact ? '96px' : '128px'} />;

    const to = `/product/${product._id}`;

    return (
        <Box display='flex' gap={compact ? '12px' : '16px'} py={compact ? '12px' : '16px'} borderBottom='1px solid' borderColor='raano.border' >
            <Box as={RouterLink} to={to} state={{ productId: product._id }} width={compact ? '64px' : { base: '84px', md: '104px' }} flexShrink={0} bg='raano.imageBg' sx={{ aspectRatio: '2 / 3' }} >
                <Image src={product.imageUrl} alt={product.name} width='100%' height='100%' objectFit='cover' />
            </Box>
            <Box flex={1} minWidth={0} >
                <Box display='flex' justifyContent='space-between' gap='8px' >
                    <Text as={RouterLink} to={to} state={{ productId: product._id }} fontSize={compact ? '13px' : '15px'} fontWeight={500} noOfLines={2} >{product.name}</Text>
                    <Text textStyle='condensed' fontSize={compact ? '15px' : '17px'} flexShrink={0} >{formatPrice(product.price * item.amount)}</Text>
                </Box>
                <Box display='flex' gap='6px' flexWrap='wrap' mt='6px' >
                    {item.size && <Text fontSize='12px' px='8px' py='2px' border='1px solid' borderColor='raano.border' borderRadius='4px' >Size: {item.size}</Text>}
                    {product.color && <Text fontSize='12px' px='8px' py='2px' border='1px solid' borderColor='raano.border' borderRadius='4px' textTransform='capitalize' >Color: {product.color}</Text>}
                </Box>
                <Box display='flex' alignItems='center' justifyContent='space-between' mt='10px' >
                    <QuantityStepper value={item.amount} onChange={onChangeAmount} />
                    <Box as='button' aria-label={`Remove ${product.name}`} width='32px' height='32px' display='flex' alignItems='center' justifyContent='center' color='blackAlpha.700' _hover={{ color: 'raano.black' }} onClick={onRemove} >
                        <DeleteOutline sx={{ fontSize: 20 }} />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default CartLine;
